<svg viewBox="0 0 16 16" 
    xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M8 6.207l-4.646 4.647-.708-.708L8 4.793l5.354 5.353-.708.708z"/>
</svg>
